import React from 'react';
import { styled } from '@mui/material/styles';
import { ReactComponent as PreloaderSVG } from '#static/media/preloader.svg';

const PreloaderRoot = styled('div')({
  textAlign: 'center',
  width: 150,
  margin: '100px auto 0'
});

export const Preloader = props => {
  const { className = '', style = {} } = props;

  return (
    <PreloaderRoot className={className} style={style}>
      <PreloaderSVG />
    </PreloaderRoot>
  );
};

export default ({ style = {} }) =>
  <PreloaderSVG
    className="spinner"
    style={{
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      margin: 'auto',
      ...style
    }}
  />;
